<app-handler-items 
    (listItemComplete)="saveTransfer($event)" 
    [titleDialog]="'Traslado de Inventario'" 
    [replyRoute]="'/almacen/traslados-inventario'"
    [itemsData]="transferData" 
    [showTargetWarehouse]="true"
    [urlItemCombo]="urlGetItemsWarehouse"
    [source]="HandlerItemsSource.OUTPUTS">
</app-handler-items>


